import * as React from "react";
const SvgFiRrGarlicAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-garlic-alt_svg__a)">
      <path
        fill="#062147"
        d="M18.63 7.367c-.522-.453-1.016-.881-1.385-1.257A4.3 4.3 0 0 1 16 3.048c0-1.654-1.09-3.049-2.744-3.049h-2.663c-1.568 0-2.594 1.539-2.594 3.109a4.27 4.27 0 0 1-1.245 3.001c-.37.376-.862.804-1.385 1.257-2.265 1.964-5.37 4.653-5.37 8.848-.072 3.099 2.266 5.694 5.212 5.786h1.788v1a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-1h2v1a1 1 0 1 0 2 0v-1h1.788c2.946-.092 5.284-2.688 5.21-5.763 0-4.219-3.102-6.907-5.367-8.87M6.244 20H5.26c-1.846-.065-3.307-1.739-3.26-3.763 0-3.305 2.595-5.553 4.68-7.358.554-.48 1.31-1.195 1.736-1.629-.027.076-.052.158-.08.227-.262.637-.624 1.348-1.008 2.1C6.237 11.717 5 14.141 5 16.762c0 1.213.47 2.343 1.243 3.238m4.257-.052c-1.897 0-3.5-1.46-3.5-3.188 0-2.14 1.12-4.337 2.109-6.276.402-.789.782-1.535 1.075-2.247.116-.283.22-.609.313-.96.093.347.199.673.317.961.293.711.673 1.457 1.075 2.246.989 1.939 2.109 4.137 2.109 6.276 0 1.728-1.603 3.188-3.5 3.188zm8.257.052h-4C15.53 19.105 16 17.974 16 16.761c0-2.62-1.236-5.045-2.327-7.185-.384-.752-.746-1.463-1.008-2.099C12.25 6.463 12 4.659 12 3.499V2.048h1c.552 0 1 .448 1 1.061 0 1.643.646 3.206 1.817 4.401.426.435.949.888 1.503 1.368C19.406 10.684 22 12.932 22 16.26c.048 2.005-1.421 3.684-3.242 3.74"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-garlic-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrGarlicAlt;
